/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiButtonStyle {
}

export enum UiButtonStyle_Enum {
  INVALID = 0,
  NORMAL = 1,
  PRIMARY = 2,
  DANGER = 3,
  UNRECOGNIZED = -1,
}

export function uiButtonStyle_EnumFromJSON(object: any): UiButtonStyle_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return UiButtonStyle_Enum.INVALID;
    case 1:
    case "NORMAL":
      return UiButtonStyle_Enum.NORMAL;
    case 2:
    case "PRIMARY":
      return UiButtonStyle_Enum.PRIMARY;
    case 3:
    case "DANGER":
      return UiButtonStyle_Enum.DANGER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UiButtonStyle_Enum.UNRECOGNIZED;
  }
}

export function uiButtonStyle_EnumToJSON(object: UiButtonStyle_Enum): string {
  switch (object) {
    case UiButtonStyle_Enum.INVALID:
      return "INVALID";
    case UiButtonStyle_Enum.NORMAL:
      return "NORMAL";
    case UiButtonStyle_Enum.PRIMARY:
      return "PRIMARY";
    case UiButtonStyle_Enum.DANGER:
      return "DANGER";
    case UiButtonStyle_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseUiButtonStyle(): UiButtonStyle {
  return {};
}

export const UiButtonStyle = {
  encode(_: UiButtonStyle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiButtonStyle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiButtonStyle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UiButtonStyle {
    return {};
  },

  toJSON(_: UiButtonStyle): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UiButtonStyle>, I>>(base?: I): UiButtonStyle {
    return UiButtonStyle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiButtonStyle>, I>>(_: I): UiButtonStyle {
    const message = createBaseUiButtonStyle();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
